import React, {useState,useEffect} from 'react';
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
//import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
//import Checkbox from '@mui/material/Checkbox';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import {Tools} from './Tools';
import {Inc,Dataset,KbinSearchCondition,SortOption} from './Inc';
import Title from './Title';
import AppBank from './AppBank';

interface KbinListSearchProps {
    update(cond:KbinSearchCondition,page:number): void,
	bankKey:string,
	bank:AppBank,
}

const KbinListSearch = (props:KbinListSearchProps)=> {
    const classes = useStyles();
    const [states,setStates] = useState(Inc.defaultKbinSearchCondition());

    const update = ()=>{
		props.bank.set(props.bankKey,JSON.stringify(states));
        props.update(states,1);
    }
	//const handleChange = (name: keyof KbinSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
	//	setStates({ ...states, [name]: event.target.value });
	//};
	//const handleChangeNumber = (name: keyof KbinSearchCondition) => (event: React.ChangeEvent<HTMLInputElement>) => {
    //    setStates({ ...states, [name]: Tools.toHan(event.target.value) });
    //    //setStates({ ...states, [name]: event.target.value });
	//};
	const handleChangeSelect = (name: keyof KbinSearchCondition) => (event: SelectChangeEvent) => {
		setStates({ ...states, [name]: event.target.value });
    };
	const handleChangeOption = (name: keyof SortOption) => (event: SelectChangeEvent) => {
        let option = states.option;
        option[name] = event.target.value;
		setStates({ ...states, "option": option});
    };
	//const handleChangeCheckboxes = (name: keyof KbinSearchCondition,index:number) => (event: React.ChangeEvent<HTMLInputElement>) => {
	//	let boolList:boolean[] = [];
	//	let idList:string[] = [];
	//	let blName:string = "";
	//	let datas:Dataset[] = [];
	//	if( blName!=="" ){
	//		if( event.target.checked ){
	//			boolList[index] = true;
	//		} else {
	//			boolList[index] = false;
	//		}
	//		for( let i=0 ; i<boolList.length ; i++ ){
	//			if( boolList[i] ){
	//				idList.push( datas[i].id );
	//			}
	//		}
	//		setStates({ ...states, [blName]: boolList, [name]: idList });
	//	}
	//};
	const resetCondition = ()=>{
		setStates(Inc.defaultKbinSearchCondition());
	}
    
	//const checkboxes = (id:keyof KbinSearchCondition,list:Dataset[])=>{
	//	const tmp = list.map( (data:Dataset,index:number)=>{
	//		const key = id+index;
	//		let v:boolean = false;
	//		return (
	//			<FormControlLabel
	//		    	key={key}
	//				control={
	//				<Checkbox
	//					checked={v}
	//					onChange={handleChangeCheckboxes(id,index)}
	//					value={String(data.id)}
	//					color="primary"
	//					className={classes.checkbox}
	//				/>
	//				}
	//				label={data.label}
	//			/>
	//		);
	//	});
	//	return (
	//		<div className={classes.checkboxes}>
	//			{tmp}
	//		</div>
	//	)
    //};

    useEffect( ()=>{
		if( props.bank.has(props.bankKey) ){
			//console.log("load");
			const cond = JSON.parse(props.bank.get(props.bankKey));
			setStates(cond);
			props.update(cond,1);
		} else {
			props.update(states,1);
		}
    },[])
    
    const years = Tools.getSelectYears();
    const months = Tools.getSelectMonths();
    const orders:Dataset[] = [
        {
            id:"kbin_start",
            label:"開催日時",
        },
        {
            id:"kbin_name",
            label:"便名",
        },
        {
            id:"kbin_organizer",
            label:"主催者",
        },
    ]
    const targets:Dataset[] = [
        {
            id:"regist_time",
            label:"開催年月",
        },
        {
            id:"arrived",
            label:"到着日",
        },
        {
            id:"completed",
            label:"完了日",
        },
    ]


    let error = false;

	return (
		<div id="kbin_list_search">
            
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Title text="検索条件" size={2}/>
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.searchButtons}>
                        <Button variant="outlined" color="primary" onClick={update} disabled={error}><SearchIcon/>検索</Button>
                    </div>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>状態</FormLabel>
                        
                        <Select
                            value={states.status}
                            onChange={handleChangeSelect('status')}
                            inputProps={{
                                name: 'status',
                                id: 'status-simple',
                            }}
                            margin="none"
                            className={classes.select}
							variant="standard"
                        >
                            <MenuItem key="status" value="">　</MenuItem>
                            {Inc.kbinStatus.map((option:Dataset,index:number) => {
                                const key = "status"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>開催年月</FormLabel>
                        <Select
                            value={states.date_year}
                            onChange={handleChangeSelect('date_year')}
                            inputProps={{
                                name: 'year',
                                id: 'year-simple',
                            }}
                            margin="none"
                            variant='standard'
                            className={classes.select}
                        >
                            <MenuItem key="year0" value="">　</MenuItem>
                            {years.map((option:Dataset,index:number) => {
                                const key = "year"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示基準</FormLabel>
                        
                        <Select
                            value={states.option.order}
                            onChange={handleChangeOption('order')}
                            inputProps={{
                                name: 'order',
                                id: 'order-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {orders.map((option:Dataset,index:number) => {
                                const key = "order"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示順</FormLabel>
                        
                        <Select
                            value={states.option.sort}
                            onChange={handleChangeOption('sort')}
                            inputProps={{
                                name: 'sort',
                                id: 'sort-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.sorts.map((option:Dataset,index:number) => {
                                const key = "sort"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} md={6} lg={6}>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <FormLabel component="label" className={classes.formLabel}>表示件数</FormLabel>
                        
                        <Select
                            value={states.option.per_page}
                            onChange={handleChangeOption('per_page')}
                            inputProps={{
                                name: 'per_page',
                                id: 'per_page-simple',
                            }}
                            margin="none"
							variant='standard'
                            className={classes.select}
                        >
                            {Inc.perPages.map((option:Dataset,index:number) => {
                                const key = "per_page"+index;
                                return (
                                    <MenuItem key={key} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>

            </Grid>
            <Button variant="outlined" fullWidth={true} className={classes.buttonReset} onClick={resetCondition}><DeleteIcon/>検索条件のリセット</Button>
		</div>
	);
}

export default KbinListSearch;
